import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private alertCtrl: AlertController) {}

  public async errorAlert(msg: string, title?: string): Promise<HTMLIonAlertElement> {
    const alert = await this.alertCtrl.create({ header: title || 'Error', message: msg, buttons: ['Ok'] });
    alert.present();
    return alert;
  }
  public async htmlAlert(msg: string, title: string | null = null, buttons: any[] = [], options: any = {}): Promise<HTMLIonAlertElement> {
    if (!buttons.length) buttons = ['Ok'];
    const opt: any = { message: msg, buttons, ...options };
    if (title) opt.header = title;
    const alert = await this.alertCtrl.create(opt);
    alert.present();
    return alert;
  }
}
